const { GET_EXP_FEED, ADD_ONE_EXP_HOME, UPDATE_ONE_EXP_HOME, OPEN_NEW_EXP,
UPDATE_EXP_FEED, RESET_EXP_FEED, HOMEPAGE_ERROR, REMOVE_ONE_EXP_HOME } = require("../types");

const INITIAL_STATE = {
  expFeed: [],
  loading: true,
  pageNum: 1,
  updatedItems: null,
  error: null,
  inHomepage: false,
  newExpIsOpen: false
};


const homepageReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action

  switch(type) {
    case GET_EXP_FEED:
      return {
        ...state,
        expFeed: payload.exp,
        pageNum: state.pageNum + 1,
        loading: false,
        inHomepage: true

      }
    case HOMEPAGE_ERROR:
      return {
        ...state,
        expFeed: payload.exp,
        error: payload.err.err.message,
        loading: false
      }
    case UPDATE_EXP_FEED:
      return {
        ...state,
        expFeed: [...state.expFeed, ...payload.exp],
        pageNum: state.pageNum + 1,
        updatedItems: payload.exp.length,
        loading: false 
      }
    case RESET_EXP_FEED:
      return {
        ...state,
        expFeed: [],
        pageNum: 1,
        loading: false,
        updatedItems: null,
        inHomepage: false,
        newExpIsOpen: false
      }
    case ADD_ONE_EXP_HOME:
      return {
        ...state,
        expFeed: [payload, ...state.expFeed], 
        loading: false
      }
    case REMOVE_ONE_EXP_HOME:
      return {
        ...state,
        expFeed: state.expFeed.filter(exp => exp._id !== payload),
        loading: false
      }
    case UPDATE_ONE_EXP_HOME:
      let index = state.expFeed.findIndex(exp => exp._id === payload._id);
      state.expFeed.splice(index, 1, payload); 
      return {
        ...state,
        expFeed: [...state.expFeed],
        loading: false
      }
    case OPEN_NEW_EXP:
      return {
        ...state,
        newExpIsOpen: payload
      }
    default:
      return state; 
  }
}


export default homepageReducer;